import { useEffect, useRef, useState, ChangeEvent } from "react";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import {
  InputsContainer,
  Label,
} from "../../screens/complaint/Complaint.styled";
import User from "../../stores/UserStore";

import { BaseProps } from "./interfaces";
import {
  ButtonsContainer,
  OutputContainer,
  PropertyDetail,
  TabContainer,
} from "./move-inTabs.styled";
import General from "../../stores/GeneralStore";
import { style } from "@mui/system";
import { Document } from "../Temporary Components/SocialCaseModal.styled";
import { NotifyError } from "../../../src/utils/ShowError";
import { SpinnerRaw } from "../SpinnerRaw/SpinnerRaw";
import { toJS } from "mobx";
import trashIcon from "../../assets/trash.svg";

interface Obj {
  [key: string]: any;
}
interface FileUpload {
  mediaType: string;
  fileName: string;
  buffer: string;
}
interface Props extends BaseProps {
  premise: Obj;
  Owner: boolean;
  saveloader?: Boolean;
  Submit: (fileData: any) => Promise<void>;
}
interface OptionalFile{
  id: number,
  name: string
}

export const Output = ({
  Submit,
  Previous,
  Owner,
  premise,
  saveloader,
}: Props) => {
  // console.log("***ewww: ",Owner)

  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  const [uploadedFiles, setUploadedFiles] = useState<any>([]);
  const [optionalUploadedFiles, setOptionalUploadedFiles] = useState<any>([]);
  const customerMessage = useRef<HTMLTextAreaElement | null>(null);
  const [isConfirmed, setConfirmed] = useState(false);
  
  const handleAddOptionalDocument = () => {
    const optionalDocs = [...optionalUploadedFiles];
    const maxId = optionalDocs.length > 0 ? Math.max(...optionalDocs.map(doc => doc.id)) : 0;
    const id = maxId + 1;
    const name = "Optional Attachment (" + id + ")";
    const optionalDoc: OptionalFile = { id, name };
    optionalDocs.push(optionalDoc)
    setOptionalUploadedFiles(optionalDocs);
  }

  const handleRemoveOptionalDocument = (id: number) => {
    setOptionalUploadedFiles((prevFiles: OptionalFile[]) => 
      prevFiles.filter(file => file.id !== id)
    );
  }
  
  const handleFileEvent = (e: any) => {
    const chosenFiles = e.target.files[0];
    handleUpload(chosenFiles);
  };
  const handleUpload = (files: any) => {
    const uploaded = [...uploadedFiles];
    // files.some((file:any) => {
    uploaded.push(files);
    // })

    setUploadedFiles(uploaded);
  };
  const [disbleMovein, setDisableMovein] = useState(true);
  const handleUploadFileChange = async (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const files: FileList | null = event.target.files;
    const fileUploadPromises: Promise<FileUpload>[] = [];

    if (files) {
      for (let i = 0; i < files.length; i++) {
        const file: File = files[i];

        // Check if the file is a PDF and within the size limit
        if (file.type === "application/pdf" && file.size <= 10485760) { // 10 MB in bytes
          const promise = new Promise<FileUpload>((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
              const buffer = reader.result?.slice(28) as string;
              const fileName = file.name;
              const mediaType = file.type;

              const fileUpload: FileUpload = { mediaType, fileName, buffer };
              resolve(fileUpload);
            };
            reader.onerror = () => {
              // Handle file reading error
              reject(new Error("Error reading file"));
            };
          });

          fileUploadPromises.push(promise);
        } else {
          // Handle invalid file type or size
          if (file.type !== "application/pdf") {
            NotifyError(
              General?.codeLabels["cm_complaint_error"]?.label !== undefined
                ? General?.codeLabels["cm_complaint_error"]?.label
                : "Only PDF files are allowed"
            );
          } else {
            NotifyError(
              General?.codeLabels['cm_uploaderror']?.label
            );
          }
        }
      }

      Promise.all(fileUploadPromises)
        .then((uploadedFilesfun) => {
          // setFieldValue("uploadedFilesData", uploadedFiles);
          // Update Formik field value
          const uploaded = [...uploadedFiles];
          // files.some((file:any) => {
          uploaded.push(uploadedFilesfun);
          setUploadedFiles(uploaded);
          if (uploaded.length > 1) {
            setDisableMovein(false);
          }
        })
        .catch((error) => {
          console.error("Error while processing file uploads:", error);
        });
    }
  };

  const handleNext = () => {
    var filearr: any = [];
    const uploadData = uploadedFiles?.map((file: any) => {
      var newuploadedFile = {
        mediaType: file[0]?.mediaType,
        fileName: file[0]?.fileName,
        buffer: file[0]?.buffer,
      };
      filearr.push(newuploadedFile);
    });
    const fileData = {
      customerMessage: customerMessage.current?.value,
      files: filearr,
    };

    if (filearr.length > 1 || Owner || !User?.info?.personId) {
      Submit(fileData);
      setDisableMovein(true);
      return;
    } else {
      NotifyError(
        General?.codeLabels["cm_complaint_upload"]?.label
          ? General?.codeLabels["cm_complaint_upload"]?.label
          : "Upload Attachments"
      );
    }
  };
  const mandatoryDocuments = [
    { key: "emiratesIDFile", label: "Copy of Emirates ID" },

    { key: "tenantContractFile", label: "Copy of Tenant Contract" },
  ];
  return (
    <>
      <TabContainer>
        {!User?.info?.personId ? (
          <OutputContainer
            style={{ width: General?.isLargeScreen ? "" : "100%" }}
          >
            <p
              style={{
                fontFamily: "Segoe UI",
                fontStyle: "normal",
                fontWeight: "700",
                fontSize: "16px",
                lineHeight: "20px",
                color: contrast?.contrastColor ? contrast?.contrastColor : General?.ColorAss,
                marginTop: "2rem",
              }}
            >
              {`${General?.codeLabels["cm_registration_confirm_details"]?.label
                  ? General?.codeLabels["cm_registration_confirm_details"]
                    ?.label
                  : "Please Confirm below details as"
                } ${Owner
                  ? General?.codeLabels["cm_owner"]?.label
                  : General?.codeLabels["cm_tenant"]?.label
                }`}
            </p>
            <PropertyDetail>
              <b
                style={{
                  fontFamily: "Segoe UI",
                  fontStyle: "normal",
                  fontWeight: "700",
                  fontSize: "16px",
                  lineHeight: "20px",
                  color: contrast?.contrastColor ? contrast?.contrastColor : General?.ColorAss,
                }}
              >
                {General?.codeLabels["cm_propertydet"]?.label !== undefined
                  ? General?.codeLabels["cm_propertydet"]?.label
                  : "Property Details"}
              </b>
              <span
                style={{
                  fontFamily: "Segoe UI",
                  fontStyle: "normal",
                  fontWeight: "400",
                  fontSize: "20px",
                  lineHeight: "24px",
                  color: contrast?.contrastColor ? contrast?.contrastColor : General?.ColorAss,
                }}
              >
                {premise.premiseDetails}
              </span>
            </PropertyDetail>
            <PropertyDetail>
              <b
                style={{
                  fontFamily: "Segoe UI",
                  fontStyle: "normal",
                  fontWeight: "700",
                  fontSize: "16px",
                  lineHeight: "20px",
                  color: contrast?.contrastColor ? contrast?.contrastColor : General?.ColorAss,
                }}
              >
                
                {General?.codeLabels["cm_propertyusage"]?.label !== undefined
                  ? General?.codeLabels["cm_propertyusage"]?.label
                  : "Property Usage"}
              </b>
              <span
                style={{
                  fontFamily: "Segoe UI",
                  fontStyle: "normal",
                  fontWeight: "400",
                  fontSize: "20px",
                  lineHeight: "24px",
                  color: contrast?.contrastColor ? contrast?.contrastColor : General?.ColorAss,
                }}
              >
                
                {premise.premiseUsage}
              </span>
            </PropertyDetail>
            <div
              style={{
                display: "flex",
                flexDirection: General?.isLargeScreen ? "row" : "column",
                gap: General?.isLargeScreen ? "140px" : "1rem",
              }}
            >
              <Label
                style={{
                  fontFamily: "Segoe UI",
                  fontStyle: "normal",
                  fontWeight: "700",
                  fontSize: "16px",
                  width: General?.isLargeScreen ? "" : "100%",
                  color: contrast?.contrastColor ? contrast?.contrastColor : General?.ColorAss,
                }}
              >
                {General?.codeLabels["cm_accountid"]?.label !== undefined
                  ? General?.codeLabels["cm_accountid"]?.label
                  : "Account Numbe"}
                <input
                  readOnly={true}
                  className="Accountinput"
                  style={{
                    width: General?.isLargeScreen ? "317px" : "100%",
                    height: "46px",
                    padding: "10px",
                    color: contrast?.contrastColor ? contrast?.contrastColor : General?.ColorAss,
                    background: contrast?.contrastBackground ? contrast?.contrastBackground : "",
                  }}
                  type="text"
                  defaultValue={
                    Owner
                      ? premise?.ownerAccount?.accountNumber
                      : premise?.tenantAccount?.accountNumber
                  }
                />
              </Label>
             
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                marginBottom: "20px",
                gap: "0.5rem",
              }}
            >
              <input
                style={{
                  height: "20px",
                  width: "20px",
                  fontFamily: "Segoe UI",
                  fontStyle: "normal",
                  fontWeight: "700",
                  fontSize: "16px",
                  lineHeight: "20px",
                  alignSelf: "center",
                  background: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "",
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "rgba(182, 191, 220, 1)",
                }}
                type="checkbox"
                onChange={() => setConfirmed(!isConfirmed)}
              />
              <label

                style={{
                  color: contrast?.contrastColor ? contrast?.contrastColor : General?.ColorAss,
                  marginTop: "0.3rem",
                }}
              >
                {General?.codeLabels["cm_registration_confirm_information"]
                  ?.label
                  ? General?.codeLabels["cm_registration_confirm_information"]
                    ?.label
                  : "I confirm that this information is correct"}
              </label>
            </div>
          </OutputContainer>
        ) : (
          <TabContainer>
            <h3
              style={{
                color: General.contrast.contrastBackground ? General.contrast.contrastColor : General?.ColorAss
              }}
            >
              {General?.codeLabels["cm_nocmandatoryattachments"]?.label}
            </h3>
            <div style={{ display: "flex", gap: "15px" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flex: 1,
                  gap: "15px",

                }}
              >
                <Document

                  exists={false}
                  mainText={
                    General?.codeLabels["cm_copy_tenancy"]?.label !== undefined
                      ? General?.codeLabels["cm_copy_tenancy"]?.label
                      : "Copy of Tenant Contract"
                  }
                  subText={
                    General?.codeLabels["cm_mandatory_document"]?.label !==
                      undefined
                      ? General?.codeLabels["cm_mandatory_document"]?.label
                      : "Mandatory Document"
                  }
                  onChange={handleUploadFileChange}
                  inputName={"tenantContractFile"}
                />
                <Document
                  exists={false}
                  mainText={
                    General?.codeLabels["cm_emirate_id_doc"]?.label !==
                      undefined
                      ? General?.codeLabels["cm_emirate_id_doc"]?.label
                      : "Copy of Emirates ID"
                  }
                  subText={
                    General?.codeLabels["cm_mandatory_document"]?.label !==
                      undefined
                      ? General?.codeLabels["cm_mandatory_document"]?.label
                      : "Mandatory Document"
                  }
                  onChange={handleUploadFileChange}
                  inputName={"emiratesIDFile"}
                />
                <div
                  style={{
                    marginTop: "8px",
                    marginBottom: "8px",
                    fontSize: "0.85rem",
                    color: contrast?.contrastColor ? contrast?.contrastColor : General?.ColorAss,
                    background: contrast?.contrastBackground ? contrast?.contrastBackground : "transparent",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  {(() => {
                    const label = General?.codeLabels["cm_attachment3"]?.label;
                    if (label) {
                      // replace <br> with newline and move text after '*' to the next line (remove the '*'), collapse multiple newlines and trim
                      const cleaned = label
                        .replace(/<br\s*\/?>/gi, "\n")
                        .replace(/\*\s*/g, "\n")
                        .replace(/\n{2,}/g, "\n")
                        .trim();
                      return cleaned;
                      return cleaned;
                    }
                    return "*If the EID is expired, please attach the renewal application form as well.";
                  })()}
                </div>
                
                    <div
                 style={{
                   width: General?.isLargeScreen ? "210px" : '100%',
                   height: "40px", // Increased height to match the image
                   display: "flex", // Centering content
                   justifyContent: "center", // Horizontally centered
                   alignItems: "center", // Vertically centered
                   fontFamily: "Segoe UI",
                   fontStyle: "normal",
                   fontWeight: "700",
                   fontSize: ".8rem",
                   lineHeight: "20px",
                   padding: "5px 10px", // Added padding
                   border: "2px solid #101E8E", // Blue border to match the image
                   background: contrast?.contrastColor ? contrast?.contrastColor : "#FFFFFF", // Default white background
                   color: contrast?.contrastBackground ? contrast?.contrastBackground : "#101E8E", // Blue text color
                   cursor: "pointer", // Pointer cursor for button feel
                   borderRadius: "5px", // Rounded corners
                   transition: "background-color 0.3s ease", // Smooth hover effect
                 }}
                 onClick={handleAddOptionalDocument}
                 onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#F0F0F0"} // Hover effect
                 onMouseLeave={(e) => e.currentTarget.style.backgroundColor = contrast?.contrastColor ? contrast?.contrastColor : "#FFFFFF"} // Revert on mouse leave
               >
                 {General?.codeLabels["cm_add_attachment"]?.label !== undefined
                   ? General?.codeLabels["cm_add_attachment"]?.label
                   : "Add Document"}
               </div>
                {optionalUploadedFiles.map((optionalFile: OptionalFile) => (
                  <div style={{display: "flex", justifyContent: "space-between", alignItems: 'center'}}>
                    <div style={{width: '100%'}}>
                      <Document
                        exists={false}
                        mainText={optionalFile.name}
                        subText={
                          General?.codeLabels["cm_optional_document"]?.label !==
                            undefined
                            ? General?.codeLabels["cm_optional_document"]?.label
                            : "Optional Document"
                        }
                        onChange={handleUploadFileChange}
                        inputName={optionalFile.name}
                        removeButton={
                          <button
                            type="button"
                            style={{
                              cursor: "pointer",
                              background: "none",
                              border: 0,
                              // marginLeft: "8px",
                            }}
                            onClick={() => handleRemoveOptionalDocument(optionalFile.id)}
                          >
                            <img src={trashIcon} alt="Remove Optional Attachment" />
                          </button>
                        }
                      />
                    </div>
                    {/* <div>
                      <button type="button" style={{cursor: 'pointer', background: 'none', border: 0 }} onClick={() => handleRemoveOptionalDocument(optionalFile.id)}>
                          <img src={trashIcon} alt="Remove Optional Attachment"/>
                      </button>
                    </div> */}
                  </div>
                ))}

              </div>

              {General?.isLargeScreen && (
                <textarea
                  style={{
                    flex: 1, color: General.contrast.contrastBackground ? General.contrast.contrastBackground : General?.ColorAss,
                    background: General.contrast.contrastColor ? General.contrast.contrastColor : contrast?.contrastBackground
                  }}
                  placeholder={General?.codeLabels["cm_custommessage"]?.label}
                  ref={customerMessage}
                />
              )}
            </div>
            {!General?.isLargeScreen && (
              <textarea
                style={{ flex: 1 }}
                placeholder={General?.codeLabels["cm_custommessage"]?.label}
                ref={customerMessage}
              />
            )}
          </TabContainer>
        )}
        <hr style={{ width: "100%" }} />
        <ButtonsContainer
          style={{
            marginTop: "20px",
            justifyContent: "start",
            gap: "2.5rem",
            flexDirection: General?.isLargeScreen ? "row" : "column",
            width: General?.isLargeScreen ? "" : "100%",
          }}
        >
          <ButtonSecondary
            style={{
              width: General?.isLargeScreen ? "163px" : "100%",
              height: "50px",
              fontFamily: "Segoe UI",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "16px",
              lineHeight: "20px",
              padding: "auto",
              background: contrast?.contrastColor
              ? contrast?.contrastColor
              : ColorAss || "#101E8E",
            color: contrast?.contrastBackground
              ? contrast?.contrastBackground
              : "white",border: 'none'
            }}
            onClick={Previous}

          >
            {General?.codeLabels["cm_back"]?.label !== undefined
              ? General?.codeLabels["cm_back"]?.label
              : "BACK"}
          </ButtonSecondary>
          {User?.info?.personId ? (
            <ButtonSecondary
              style={{
                fontFamily: "Segoe UI",
                fontStyle: "normal",
                fontWeight: "700",
                fontSize: "16px",
                lineHeight: "20px",
                width: General?.isLargeScreen ? "163px" : "100%",
                height: "50px",
                padding: "auto",
                background: contrast?.contrastColor
                ? contrast?.contrastColor
                : ColorAss || "#101E8E",
              color: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "white",
                opacity: disbleMovein ? '0.5' : '1',
                whiteSpace: 'nowrap',
                border: 'none'
              }}
              onClick={handleNext}
              disabled={disbleMovein}

            >
              {saveloader ? (
                <SpinnerRaw width={30} height={30} />
              ) : General?.codeLabels["cm_submit"]?.label !== undefined ? (
                General?.codeLabels["cm_submit"]?.label
              ) : (
                "CONTINUE"
              )}
            </ButtonSecondary>
          ) : (
            <ButtonSecondary
              style={{
                fontFamily: "Segoe UI",
                fontStyle: "normal",
                fontWeight: "700",
                fontSize: "16px",
                lineHeight: "20px",
                width: General?.isLargeScreen ? "163px" : "100%",
                height: "50px",
                padding: "auto",
                background: contrast?.contrastColor
                ? contrast?.contrastColor
                : ColorAss || "#101E8E",
              color: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "white",
                opacity: isConfirmed ? "1" : "0.5",
                whiteSpace: 'nowrap',
                border: 'none'
              }}
              onClick={handleNext}
              disabled={!isConfirmed}

            >
              {General?.codeLabels["cm_btncontinue"]?.label !== undefined
                ? General?.codeLabels["cm_btncontinue"]?.label
                : "CONTINUE"}
            </ButtonSecondary>
          )}
        </ButtonsContainer>
      </TabContainer>
    </>
  );
};
